module.exports = __webpack_public_path__ + "img/minus-p.8e956a61.svg";